module.exports = __webpack_public_path__ + "media/images/client/favicons/android-chrome-36x36-9a47ade9cbfb1dce629e65d7f1ac567a.png";